// extracted by mini-css-extract-plugin
module.exports = {"formitemRow":"invoiceModal_formitemRow__xVpF0"};